module.exports = __webpack_public_path__ + "img/logo3.7d1530fe.png";